import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import SuccessIcon from 'assets/img/verification/success.svg';
import { useSearchParams } from 'react-router-dom';
import UserInviteForm from 'components/modules/auth/Invite/UserInviteForm';
import useInviteUser from 'components/modules/auth/Invite/hook/useInviteUser';
import Loader from 'components/base/Loader';
import LinkExpired from 'pages/verification/expired/LinkExpired';

function UserInvite() {
  const [URLSearchParams] = useSearchParams();
  const token = URLSearchParams.get('token');
  const { getInvitation, data, isLoading, isError } = useInviteUser(token);

  useEffect(() => {
    getInvitation();
  }, []);

  if (isLoading) return <Loader />;
  if (!(URLSearchParams.size === 1 && token) || isError) return <LinkExpired />;

  return (
    <Container
      fluid
      className="vh-100 d-flex justify-content-center align-items-center flex-column"
    >
      <img src={SuccessIcon} width={150} className="mb-2" />
      <p className="fs-5">
        Welcome to {data?.organization}, {data?.name}!
      </p>
      <p className="text-center mb-4">
        You have been invited to join as an {data?.role}. <br /> Complete your
        setup below.
      </p>
      <UserInviteForm
        token={token}
        meta={{
          name: data?.name || '',
          organizationName: data?.organization || ''
        }}
      />
    </Container>
  );
}

export default UserInvite;
